import { Grid } from '@mui/material';
import DashboardKurulMeetingsCard from '../DashboardKurulMeetingsCard';
import DashboardUserInfoMeetingsCard from '../DashboardUserInfoMeetingsCard';
import DashboardYKMeetingsCard from '../DashboardYKMeetingsCard';
import DashboardAnnouncementsCard from '../DashboardAnnouncementsCard';

function DashboardYkAndKurulDesign({ countList, countUserInfo, ykCountList }) {

    return (
        <>
            {/* <Grid container spacing={1} direction="row" style={{ marginBottom: 3 }}>
                <Grid item xs={12} md={9} lg={9}>
                    <DashboardKurulMeetingsCard countList={countList} />
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                    <DashboardUserInfoMeetingsCard countList={countUserInfo} />
                </Grid>

                <Grid item xs={12} md={12} lg={9}>
                    <DashboardYKMeetingsCard countList={ykCountList} />
                </Grid>
            </Grid> */}








            <Grid item xs={12} md={9} lg={9}>

                <Grid item xs={12} md={12} lg={12} style={{ marginBottom: 5 }}>
                    <DashboardKurulMeetingsCard countList={countList} />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ marginBottom: 5 }}>
                    <DashboardYKMeetingsCard countList={ykCountList} />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <DashboardUserInfoMeetingsCard countList={countUserInfo} />
                </Grid>



            </Grid>


            <Grid item xs={12} lg={3}>

                <DashboardAnnouncementsCard />

            </Grid>













        </>
    );
}

export default DashboardYkAndKurulDesign; 